export const text = {
  price: "Pricing",
  choosePlan: "Get Started or Choose a Plan",
  upgrade: "Upgrade, modify and cancel any time!",
};
